// extracted by mini-css-extract-plugin
module.exports = {"compact":"StepperProgress_compact__3G2eZ","number":"StepperProgress_number__MKhB1","active":"StepperProgress_active__Wc4AG"};